import { render, staticRenderFns } from "./userInfo_personalData.vue?vue&type=template&id=734b044c&scoped=true&"
import script from "./userInfo_personalData.vue?vue&type=script&lang=js&"
export * from "./userInfo_personalData.vue?vue&type=script&lang=js&"
import style0 from "./userInfo_personalData.vue?vue&type=style&index=0&id=734b044c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "734b044c",
  null
  
)

export default component.exports